import { useOidcStore } from "vue3-oidc";
import { Configuration } from "@socotec.io/document-sdk";
import { Configuration as ContributorsConfiguration } from "@socotec.io/contributors-sdk";
import { Configuration as UserManagementConfiguration } from "@socotec.io/user-management-sdk";
import { Configuration as MaterialsConfiguration } from "@socotec.io/materials-sdk";
import { unauthorizedRetryMiddleware } from "./clients/unauthorizedRetry";
import { offlineModeMiddleware } from "./clients/offlineMode";

const tokenGetter = () => useOidcStore().state.value.token;
const bearerTokenGetter = () => `Bearer ${useOidcStore().state.value.token}`;
const middleware = [offlineModeMiddleware, unauthorizedRetryMiddleware];

export const config = new Configuration({
  basePath: import.meta.env.VITE_APP_U_DOCUMENT_BACK_URL,
  accessToken: tokenGetter,
  middleware,
});

export const contributorsConfig = new ContributorsConfiguration({
  basePath: import.meta.env.VITE_APP_CONTRIBUTORS_REST_API_URL,
  accessToken: tokenGetter,
  middleware,
});

export const userManagementConfig = new UserManagementConfiguration({
  basePath: import.meta.env.VITE_APP_USER_MANAGEMENT_REST_API_URL,
  accessToken: bearerTokenGetter,
  middleware,
});

export const materialsConfig = new MaterialsConfiguration({
  basePath: import.meta.env.VITE_APP_MATERIAL_API_URL?.replace(
    /\/(api)?\/?$/,
    ""
  ),
  accessToken: tokenGetter,
  middleware,
});

export const useApi = (apiClass) => {
  return new apiClass(config);
};

export async function fetchAll(client, func, filters = {}, limit = 1000) {
  let page = 1;
  // forcing a page size of 100 to avoid issues with very large page sizes
  const pageSize = Math.max(filters.page_size ?? 0, 100);
  let allResults = [];
  let hasMore = true;
  while (hasMore) {
    const { count, results } = await client[func]({
      ...filters,
      pageSize,
      page,
    });

    allResults = allResults.concat(results);
    page += 1;

    hasMore = allResults.length < count && allResults.length < limit;
  }

  return { results: allResults };
}
